module.exports = __webpack_public_path__ + "static/media/announcement-speaker-icon.d03355b4.svg";